<!--
 * @Author: wangjiaxiang
 * @Date: 2022-07-06 15:16:16
 * @LastEditTime: 2022-07-18 10:13:55
 * @LastEditors: wangjiaxiang
 * @Description: 儿歌故事新增分类标签
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/components/songClassification.vue
 * 
-->
<template>
  <div class="song-classify">
    <van-sticky
      :z-index="1"
      :offset-top="navHeight + searchHeight + songTagHeight"
    >
      <div class="fixed">
        <van-tabs v-model="tagIndex" @click="onClick">
          <van-tab
            v-for="(item, index) in tagList"
            :title="item.name"
            :key="index"
          ></van-tab>
        </van-tabs>
        <!-- 分类下拉按钮 -->
        <div class="select-class" @click.stop="showSongClassification">
          <van-icon name="arrow-down" :size="16" />
        </div>
      </div>
    </van-sticky>
  </div>
</template>

<script>
export default {
  name: "",
  props: [
    "navHeight",
    "searchHeight",
    "tagList",
    "songTagHeight",
    "songTagActiveId",
  ],
  data() {
    return {
      tagIndex: 0,
    };
  },
  watch: {
    songTagActiveId(val) {
      this.tagIndex = this.tagList.findIndex((item) => {
        return item.id == val
      });
    },
  },
  components: {},

  computed: {},

  created() {},

  mounted() {},
  methods: {
    // 显示儿歌分类
    showSongClassification() {
      this.$emit("showSongClassification");
    },
    onClick(index, title) {
      console.log(index, title);
      this.tagIndex = index;
      this.$emit("switchSongTag", index, "滚动标签");
    },
  },
};
</script>
<style lang="less" scoped>
.song-classify {
  background: #fff;
  /deep/ .van-tabs__nav--line.van-tabs__nav--complete {
    padding-left: 0 !important;
  }
  /deep/ .van-tabs__wrap--scrollable .van-tab:first-child {
    margin-left: 0 !important;
  }
  /deep/ .van-tabs--line .van-tabs__wrap {
    margin-left: 16px;
    width: 317px;
  }
  /deep/ .van-tabs__wrap .van-tabs__nav .van-tab:first-child {
    margin-left: 0 !important;
  }
  /deep/ .van-tab {
    padding: 0 12px;
    margin-left: 12px;
    flex: none;
  }
  .fixed {
    background: #fff;
    position: relative;
  }
  // 分类下拉
  .select-class {
    width: 38px;
    height: 42px;
    text-align: left;
    font-size: @indexFontSize18;
    position: absolute;
    top: 0px;
    right: 0;
    z-index: 1;
    background: @expertFontColor255;
    i {
      margin-left: 8px;
      line-height: 44px;
    }
  }
}
</style>
